import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend, Filler } from 'chart.js';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://7fd3af368478c159aef8183398ecf415@o4510646422667264.ingest.de.sentry.io/4510759902314576",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Register Chart.js components
Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend, Filler);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

